import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";

function SubmitBtn({ isSignIn, isLoading }) {
  const { t } = useTranslation();

  return (
    <button type="submit" className="authPage__submit" disabled={isLoading}>
      {isLoading ? "Please wait…" : isSignIn ? t("auth.submitSignIn") : t("auth.submitSignUp")}
    </button>
  );
}

export default SubmitBtn;
